import { Typography } from 'lighthouse';

import { rialToToman } from '@/utilities/Financial';
import { withSeparator } from '@/utilities/withSeparator';

import { PriceAdjustmentsProps } from './models';

import { ReceiptItem } from 'iconsax-react';

const PRICE_ADJUSTMENT_LABELS: Record<string, string> = {
    LABOR_FEE: 'اجرت'
};

const PriceAdjustments = ({ adjustments }: PriceAdjustmentsProps) => {
    if (!adjustments?.length) {
        return null;
    }

    return (
        <div className='space-y-2'>
            <hr className='opacity-10' />
            {adjustments.map((adjustment, index) => (
                <div key={`${adjustment.type}-${adjustment.name}-${index}`} className='flex items-center justify-between gap-3'>
                    <div className='flex min-w-0 items-center gap-1.5'>
                        <ReceiptItem color='currentcolor' className='size-4 shrink-0 text-primary' />
                        <Typography className='min-w-0 text-xs text-primary'>
                            {PRICE_ADJUSTMENT_LABELS[adjustment.name] ?? adjustment.name}
                        </Typography>
                    </div>
                    <Typography className='shrink-0 text-xs font-semibold text-primary'>
                        {withSeparator(rialToToman(adjustment.totalPrice))} <span className='text-blackHighEmphasis'>تومان</span>
                    </Typography>
                </div>
            ))}
        </div>
    );
};

export default PriceAdjustments;
